import React, { useState, useRef, useEffect } from 'react'

import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'

import * as styles from './Subnavbar.module.scss'

import { Link } from '../../molecules/link'

const SubNavLogoSVG = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    fill='none'
    viewBox='0 0 20 20'
  >
    <path fill='#FFD152' d='M0 0H20V20H0z'></path>
    <path
      stroke='#000'
      d='M15.5 5v-.5H9.904l.854.854 1.198 1.198-2.393 2.392H3.944v2.112H10.437l.147-.147 2.864-2.865 1.198 1.198.758.758-.758.758-1.198 1.198-1.59-1.591-.354-.354-.354.354-.785.785-.354.354.354.353 1.59 1.591-1.197 1.198-.854.854H15.5V5z'
    ></path>
  </svg>
)

const DEFAULT_LOGO_LINK = {
  label: 'Resources',
  to: '/resources/',
  showChevron: false
}

const DEFAULT_LINKS = [
  {
    label: 'Blog',
    to: '/blog/'
  },
  {
    label: 'Guides & reports',
    to: '/resources/guides/'
  },
  {
    label: 'Case studies',
    to: '/resources/case-studies/'
  },
  {
    label: 'Webinars',
    to: '/resources/webinars/'
  }
]

const Subnavbar: React.FC<{
  backgroundColor?: string
  logoLink?: { label: string; to: string; showChevron?: boolean }
  links?: { label: string; to: string }[]
}> = ({
  links = DEFAULT_LINKS,
  backgroundColor = 'var(--color-white)',
  logoLink = DEFAULT_LOGO_LINK
}) => {
  const location = useLocation()
  const navRef = useRef<HTMLDivElement>(null)
  const [activeLink, setActiveLink] = useState<string | null>(null)

  useEffect(() => {
    setActiveLink(location.pathname)
  }, [location])

  // Scroll to active link on initial load
  useEffect(() => {
    if (activeLink && navRef.current) {
      const activeElement = navRef.current.querySelector(
        `a[href="${activeLink}"]`
      ) as HTMLElement

      if (activeElement) {
        // Wait for layout to be complete
        setTimeout(() => {
          const navRect = navRef.current?.getBoundingClientRect()
          const activeRect = activeElement.getBoundingClientRect()

          if (navRef.current && navRect) {
            // Center the active element if possible
            const scrollPosition =
              activeRect.left +
              activeElement.offsetWidth / 2 -
              navRect.left -
              navRef.current.clientWidth / 2

            navRef.current.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            })
          }
        }, 100)
      }
    }
  }, [activeLink])

  return (
    <>
      <div className={styles.subnavbar} style={{ backgroundColor }}>
        <div className={styles.subnavbarContainer}>
          <div className={styles.subnavbarContent}>
            <div className={styles.subnavbarLogo}>
              <Link href={logoLink.to} showLeadIcon={logoLink.showChevron}>
                {logoLink.label}
              </Link>
            </div>
            <div className={styles.subnavbarNavContainer}>
              <div className={styles.subnavbarNavWrapper} ref={navRef}>
                <nav className={styles.subnavbarNav}>
                  {links.map((link, index) => (
                    <Link
                      key={index}
                      href={link.to}
                      className={
                        // if activeLink contains link.to, add active class
                        activeLink?.includes(link.to)
                          ? styles.subnavbarLinkActive
                          : styles.subnavbarLink
                      }
                    >
                      {link.label}
                    </Link>
                  ))}
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Subnavbar
